export default __webpack_public_path__ + "static/media/store_green.d7cdb6fb.svg";